import { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";

export default function ApartmentsPage() {
  const [apartments, setApartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newName, setNewName] = useState("");
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");

  useEffect(() => { fetchApartments(); }, []);

  async function fetchApartments() {
    setLoading(true);
    const { data, error } = await supabase
      .from("apartments")
      .select("id, name, active")
      .order("id", { ascending: true });

    if (!error) setApartments(data || []);
    setLoading(false);
  }

  async function addApartment() {
    const name = newName.trim();
    if (!name) return;
    const { error } = await supabase.from("apartments").insert([{ name, active: true }]);
    if (error) { alert(error.message); return; }
    setNewName("");
    fetchApartments();
  }

  function startEdit(ap) {
    setEditId(ap.id);
    setEditName(ap.name);
  }

  async function saveEdit(id) {
    const name = editName.trim();
    if (!name) return;
    const { error } = await supabase.from("apartments").update({ name }).eq("id", id);
    if (error) { alert(error.message); return; }
    setEditId(null);
    setEditName("");
    fetchApartments();
  }

  async function toggleActive(ap) {
    const { error } = await supabase
      .from("apartments")
      .update({ active: !ap.active })
      .eq("id", ap.id);
    if (error) { alert(error.message); return; }
    setApartments(a =>
      a.map(x => (x.id === ap.id ? { ...x, active: !ap.active } : x))
    );
  }

  async function deleteApartment(id) {
    const ok = window.confirm(
      "Delete this apartment? (Tip: if reservations exist, prefer toggling Active instead.)"
    );
    if (!ok) return;
    const { error } = await supabase.from("apartments").delete().eq("id", id);
    if (error) { alert(error.message); return; }
    setApartments(a => a.filter(x => x.id !== id));
  }

  return (
    <div style={{ padding: 20, fontFamily: "sans-serif" }}>
      <h1>Apartments</h1>

      {/* Add new */}
      <div style={{ display: "flex", gap: 8, margin: "12px 0 20px" }}>
        <input
          placeholder="New apartment name"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          style={{ minWidth: 280 }}
        />
        <button onClick={addApartment}>Add</button>
      </div>

      {loading ? (
        <div>Loading…</div>
      ) : (
        <div className="responsive-table" style={{ overflowX: "auto" }}>
          <table border="1" cellPadding="12" style={{ borderCollapse: "collapse", minWidth: 600 }}>
            <thead>
              <tr>
                <th style={{ width: 80 }}>ID</th>
                <th>Name</th>
                <th style={{ width: 120 }}>Active</th>
                <th style={{ width: 220 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {apartments.map((ap) => (
                <tr key={ap.id} style={{ background: ap.active ? "white" : "#f6f6f6" }}>
                  <td>{ap.id}</td>
                  <td>
                    {editId === ap.id ? (
                      <input
                        value={editName}
                        onChange={(e) => setEditName(e.target.value)}
                        style={{ width: "100%" }}
                      />
                    ) : (
                      ap.name
                    )}
                  </td>
                  <td>
                    <label style={{ display: "inline-flex", gap: 6, alignItems: "center" }}>
                      <input
                        type="checkbox"
                        checked={!!ap.active}
                        onChange={() => toggleActive(ap)}
                      />
                      {ap.active ? "Active" : "Inactive"}
                    </label>
                  </td>
                  <td>
                    {editId === ap.id ? (
                      <>
                        <button onClick={() => saveEdit(ap.id)}>Save</button>{" "}
                        <button onClick={() => setEditId(null)}>Cancel</button>
                      </>
                    ) : (
                      <>
                        <button onClick={() => startEdit(ap)}>Edit</button>{" "}
                        <button onClick={() => deleteApartment(ap.id)}>Delete</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
              {apartments.length === 0 && (
                <tr><td colSpan={4} style={{ textAlign: "center" }}>No apartments yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
